module.exports = __webpack_public_path__ + "static/media/services-img2.bdd41e92.jpg";